import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_LAB_RESOURCES_UPDATE } from "../apiRoutes";

interface ResourceItem {
  resourceId?: string;
  profile_id: string;
  schoolId?: string;
  isDeleted?: boolean;
}

interface UpdateResourcesRequest {
  resourceList: ResourceItem[];
}

interface UpdateResourcesResponse {
  data: any;
}

export const useUpdateSchoolResourcesMutation = (options?: {
  onSuccess?: (data: UpdateResourcesResponse) => void;
  onError?: (error: any) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: UpdateResourcesRequest): Promise<UpdateResourcesResponse> => {
      const response = await axiosAuth.put(SCHOOL_LAB_RESOURCES_UPDATE, request);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["schoolLabResource"] });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
